import { useEffect, useRef } from 'react'

import { cn } from '@/lib/utils.ts'

import { markdownConverter } from '@/utils/string.ts'

import '@/components/markdown.scss'

type MarkdownVariants = 'comment'

type Props = {
  value: string
  variant?: MarkdownVariants
}

export const MarkdownViewer = ({ value, variant }: Props) => {
  const preprocessText = (text: string) => {
    // biome-ignore lint/suspicious/noMisleadingCharacterClass: remove special zero width unicode characters which could interfere with parsing
    return text.replace(/^[\u200B\u200C\u200D\u200E\u200F\uFEFF]/, '')
  }

  const containerRef = useRef<HTMLDivElement>(null)

  // biome-ignore lint/correctness/useExhaustiveDependencies: add event listeners to anchors within markdown
  useEffect(() => {
    const anchors = containerRef.current?.querySelectorAll('a') ?? []

    for (const anchor of anchors) {
      const handleClick = (e: MouseEvent) => {
        e.stopPropagation()
      }
      anchor.addEventListener('click', handleClick)

      return () => {
        console.log('cleanup')
        anchor.removeEventListener('click', handleClick)
      }
    }
  }, [value])

  return (
    <div
      ref={containerRef}
      className={cn('text-contents-primary font-EN-KR-body2-regular markdown', variant)}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: display markdown
      dangerouslySetInnerHTML={{
        __html: markdownConverter.parse(preprocessText(value)),
      }}
    />
  )
}
